import React from "react";
import { emphasisPartsOf } from "../services/emphasis";
import styles from "./EmphasizedMessage.module.css";

/**
 * A message as it was written, with its dates, batch ids, loop request numbers
 * and email addresses in bold, so they stand out without changing a word.
 *
 * @param {{ text: string }} props
 */
const EmphasizedMessage = ({ text }) =>
  emphasisPartsOf(text)?.map((part, index) =>
    part?.isKey ? (
      <strong key={`${index}-${part?.text}`} className={part?.isDate ? styles.date : undefined}>
        {part?.text}
      </strong>
    ) : (
      <React.Fragment key={`${index}-${part?.text}`}>{part?.text}</React.Fragment>
    ),
  );

export default EmphasizedMessage;
